import { gql, useLazyQuery, useQuery } from "@apollo/client";
import { SellerListQuery, SellerListQueryVariables } from "@/gql/graphql";

const query = gql`
  fragment SellerListItems on StatisticsBySellerListItem {
    seller {
      id
      name
    }
    negotiationStatusStatistics {
      accounts
      statistics {
        negotiationStatus {
          id
          name
        }
        numberVolumeStatistics {
          percentageOfAccount
          percentageOfVolume
        }
      }
    }
  }
  query SellerList($filterOptions: StatisticsSearchSellerListByFilterOptions!) {
    statistics {
      sellerList {
        byFilter(filterOptions: $filterOptions) {
          items {
            ...SellerListItems
          }
        }
      }
    }
  }
`;

export const useSellerListQuery = () => {
  const [fetchSellerList, { error, loading, data }] = useLazyQuery<
    SellerListQuery,
    SellerListQueryVariables
  >(query, {
    fetchPolicy: "network-only",
  });

  return {
    error,
    loading,
    fetchSellerList,
    sellerItems: data?.statistics.sellerList.byFilter?.items,
  };
};
